import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useToast } from "@/components/ui/use-toast";

const NotificationSettings = () => {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  
  // Sample notification settings - would be fetched from API in a real app
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [browserNotifications, setBrowserNotifications] = useState(true);
  const [messageNotifications, setMessageNotifications] = useState(true);
  const [offerNotifications, setOfferNotifications] = useState(true);
  const [reviewNotifications, setReviewNotifications] = useState(true);
  const [marketingNotifications, setMarketingNotifications] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // Implement notification settings update logic here
      
      toast({
        title: "Notification preferences updated",
        description: "Your notification preferences have been saved.",
      });
    } catch (error) {
      toast({
        title: "Error updating preferences",
        description: "There was a problem saving your notification preferences.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="email-notifications" className="text-base">
              Email Notifications
            </Label>
            <p className="text-sm text-muted-foreground">
              Receive notifications via email
            </p>
          </div>
          <Switch
            id="email-notifications"
            checked={emailNotifications}
            onCheckedChange={setEmailNotifications}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="browser-notifications" className="text-base">
              Browser Notifications
            </Label>
            <p className="text-sm text-muted-foreground">
              Receive push notifications in your browser
            </p>
          </div>
          <Switch
            id="browser-notifications"
            checked={browserNotifications}
            onCheckedChange={setBrowserNotifications}
          />
        </div>
      </div>
      
      <div className="space-y-4">
        <h3 className="text-lg font-medium">Notification Types</h3>
        
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="message-notifications" className="text-base">
              Messages
            </Label>
            <p className="text-sm text-muted-foreground">
              Get notified when someone sends you a message
            </p>
          </div>
          <Switch
            id="message-notifications"
            checked={messageNotifications}
            onCheckedChange={setMessageNotifications}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="offer-notifications" className="text-base">
              Offers
            </Label>
            <p className="text-sm text-muted-foreground">
              Get notified about new offers that match your criteria
            </p>
          </div>
          <Switch
            id="offer-notifications"
            checked={offerNotifications}
            onCheckedChange={setOfferNotifications}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="review-notifications" className="text-base">
              Reviews
            </Label>
            <p className="text-sm text-muted-foreground">
              Get notified when someone leaves a review on your profile or offer
            </p>
          </div>
          <Switch
            id="review-notifications"
            checked={reviewNotifications}
            onCheckedChange={setReviewNotifications}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="marketing-notifications" className="text-base">
              Marketing
            </Label>
            <p className="text-sm text-muted-foreground">
              Receive marketing updates and newsletters
            </p>
          </div>
          <Switch
            id="marketing-notifications"
            checked={marketingNotifications}
            onCheckedChange={setMarketingNotifications}
          />
        </div>
      </div>
      
      <Button type="submit" disabled={loading}>
        {loading ? "Saving..." : "Save Preferences"}
      </Button>
    </form>
  );
};

export default NotificationSettings; 